<script setup lang="ts">
import {useConfig} from '@/composables/config'
import FooterBlock from './FooterBlock.vue'

const {hourTable} = useConfig()

defineProps<{
  title?: boolean|string
  card?: boolean
}>()
</script>

<template>
  <FooterBlock
      :card="card"
      class="footer-block--hour-table"
      :title="(typeof title === 'boolean' && title) ? $t('footer.hourTable') : title"
  >
    <ul class="ma-3">
      <template v-for="hourRow of hourTable">
        <li v-if="hourRow.label">
          <span class="mr-4" v-text="$t(`days.${hourRow.label}`)" />
          <span v-text="`${hourRow.q1[0]} - ${hourRow.q2[1]}`" />
        </li>
      </template>
    </ul>
  </FooterBlock>
</template>

<style scoped lang="scss">
.footer-block--hour-table {

}
</style>